(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coverly-sammenligning"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-compare')) {
    customElements.define('coverly-compare', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.ac || !this.isConnected) return;
        this.stage = this.querySelector('.cv-compare__stage');
        this.knob = this.querySelector('[role="slider"]');
        if (!this.stage || !this.knob) return;
        this.ac = new AbortController();
        const opts = { signal: this.ac.signal };
        const move = (e) => {
          const r = this.stage.getBoundingClientRect();
          if (r.width) this.set((e.clientX - r.left) / r.width * 100);
        };
        this.stage.addEventListener('pointerdown', (e) => {
          if (!e.isPrimary || e.button !== 0) return;
          this.pid = e.pointerId;
          this.stage.setPointerCapture(e.pointerId);
          this.classList.add('is-active');
          if (e.pointerType === 'mouse') move(e);
        }, opts);
        this.stage.addEventListener('pointermove', (e) => {
          if (e.pointerId === this.pid) move(e);
        }, opts);
        const end = (e) => {
          if (e.pointerId !== this.pid) return;
          this.pid = null;
          this.classList.remove('is-active');
        };
        this.stage.addEventListener('pointerup', end, opts);
        this.stage.addEventListener('pointercancel', end, opts);
        this.knob.addEventListener('keydown', (e) => {
          const now = Number(this.knob.getAttribute('aria-valuenow'));
          const step = e.shiftKey ? 10 : 2;
          const next = { ArrowLeft: now - step, ArrowDown: now - step, ArrowRight: now + step, ArrowUp: now + step, Home: 0, End: 100 }[e.key];
          if (next === undefined) return;
          e.preventDefault();
          this.set(next);
        }, opts);
      }

      set(value) {
        const n = Number(value);
        const pos = Number.isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : 50;
        this.style.setProperty('--cvc-pos', pos + '%');
        this.knob.setAttribute('aria-valuenow', pos);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        this.pid = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-skjul-topptekst"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const update = () => {
      const wrapper = document.querySelector('.page-wrapper');
      const top = Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
      document.documentElement.classList.toggle('cv-hh-scrolled', top > 2);
    };
    document.addEventListener('scroll', update, { capture: true, passive: true });
    window.addEventListener('load', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
